var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import BreakInDamageDescriptionSectionCard from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSectionCard.vue';
import BreakInDamageDescriptionStep from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionStep.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import { GLASS_TYPE_TRAD_KEYS_AND_IMAGES, GLAZING_TYPE_TRAD_KEYS_AND_IMAGES, } from '@shared/constants/breakInDamageConstants';
import BreakInDamageDescriptionSubSection from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSubSection.vue';
import { parseLength } from '@declaration/helpers/typeFormatters';
import OutlinedNumberInput from '@declaration/components/OutlinedNumberInput.vue';
import BreakInDamageChoices from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageChoices.vue';
const layout = namespace('layout');
const breakInDamage = namespace('breakInDamage');
let DoorBrokenWindowTiles = class DoorBrokenWindowTiles extends Vue {
    constructor() {
        super(...arguments);
        this.parseLength = parseLength;
        this.isSaving = false;
        this.showValidation = false;
        this.YES_OR_NO_CHOICES = YES_OR_NO_CHOICES;
        this.glazingTypes = Object.entries(GLAZING_TYPE_TRAD_KEYS_AND_IMAGES).map(([glazingType, description]) => ({
            value: glazingType,
            tradKey: description.tradKey,
            image: description.image,
        }));
        this.glassTypes = Object.entries(GLASS_TYPE_TRAD_KEYS_AND_IMAGES).map(([glassType, description]) => ({
            value: glassType,
            tradKey: description.tradKey,
            image: description.image,
        }));
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get breakInDamage() {
        return this.change.data;
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get isValid() {
        return (!this.validation.fieldHasViolations('doorHasBrokenWindowTiles') &&
            !this.validation.fieldHasViolations('doorBiggestBrokenWindowTileHeight') &&
            !this.validation.fieldHasViolations('doorBiggestBrokenWindowTileWidth') &&
            !this.validation.fieldHasViolations('doorNumberOfBrokenWindowTiles') &&
            !this.validation.fieldHasViolations('doorWindowGlazingType') &&
            !this.validation.fieldHasViolations('doorWindowGlassType'));
    }
    update(data) {
        this.updateBreakInDamage({ changeKey: this.changeKey, data });
    }
    save() {
        this.isSaving = true;
        this.$emit('goToNextStep');
        this.isSaving = false;
    }
    revealValidation() {
        this.$store.dispatch('error/add', this.$tc('error.form.please_validate_message'));
        this.validateBreakInDamage(this.changeKey);
        this.showValidation = true;
    }
    get displayBrokenTilesQuestions() {
        return this.breakInDamage.doorHasBrokenWindowTiles;
    }
};
__decorate([
    layout.State('color')
], DoorBrokenWindowTiles.prototype, "color", void 0);
__decorate([
    breakInDamage.Getter('change')
], DoorBrokenWindowTiles.prototype, "changeGetter", void 0);
__decorate([
    breakInDamage.Action('updateDamage')
], DoorBrokenWindowTiles.prototype, "updateBreakInDamage", void 0);
__decorate([
    breakInDamage.Getter('validation')
], DoorBrokenWindowTiles.prototype, "validationGetter", void 0);
__decorate([
    breakInDamage.Action('validateAndRevealDamages')
], DoorBrokenWindowTiles.prototype, "validateBreakInDamage", void 0);
DoorBrokenWindowTiles = __decorate([
    Component({
        components: {
            OutlinedNumberInput,
            BreakInDamageDescriptionStep,
            BreakInDamageDescriptionSectionCard,
            RadioPrimaryButton,
            BreakInDamageChoices,
            BreakInDamageDescriptionSubSection,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
            isFinalStep: { type: Boolean, default: false },
        },
    })
], DoorBrokenWindowTiles);
export default DoorBrokenWindowTiles;
